import { trainCourseEntityName } from '../../backend/config/classifiers/entities/defineTrainCourseClassifier';
import { accountTrainCourseEntityName } from '../../backend/features/train-courses/shared';
import { useUserDirectoryFilter, } from '@juvare/contact-management/ui/features/user-directory/hooks/useUserDirectoryFilter';
import { useUserState } from '@juvare/contact-management/ui/hooks';
import { regionEntityName } from '@juvare/platform-sdk-react/backend/features/default-classifiers/shared';
import { useStorageList } from '@juvare/platform-sdk-react/ui/hooks';
import { isTrainFeatureEnabled } from '../utils';
import { useFeatureFlags } from './useFeatureFlags';
export function useOverrideCredentialingUserDirectoryFilter(params) {
    var _a, _b;
    const userState = useUserState();
    const { tribe: locationEnabled, skillsAndTrainings: skillsAndTrainingEnabled } = useFeatureFlags();
    const { data, error, isLoading } = useUserDirectoryFilter(params);
    const { filterData } = params;
    const { data: regionData, error: regionError } = useStorageList(regionEntityName, filterData.region
        ? {
            filter: [
                {
                    column: 'name',
                    op: '=',
                    value: filterData.region,
                },
            ],
        }
        : undefined);
    if (error || regionError) {
        return { isLoading: false, error: error || regionError };
    }
    if (!data || isLoading) {
        return { data: undefined, isLoading: isLoading };
    }
    if (filterData === null || filterData === void 0 ? void 0 : filterData.stateAndCounty) {
        data.push({ column: 'stateAndCounty', op: 'in', value: filterData.stateAndCounty });
    }
    if (locationEnabled) {
        if (filterData === null || filterData === void 0 ? void 0 : filterData.city) {
            data.push({ column: 'city', op: '=', value: filterData.city });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.postalCode) {
            data.push({ column: 'postalCode', op: '=', value: filterData.postalCode });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.state) {
            data.push({ column: 'state', op: '=', value: filterData.state });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.county) {
            data.push({ column: 'county', op: '=', value: filterData.county });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.tribeId) {
            data.push({ column: 'tribeId', op: 'in', value: filterData.tribeId });
        }
        if ((filterData === null || filterData === void 0 ? void 0 : filterData.region) && ((_a = regionData === null || regionData === void 0 ? void 0 : regionData.rows[0]) === null || _a === void 0 ? void 0 : _a.columns.counties)) {
            data.push({
                column: 'county',
                op: 'in',
                value: (_b = regionData === null || regionData === void 0 ? void 0 : regionData.rows[0]) === null || _b === void 0 ? void 0 : _b.columns.counties,
            });
        }
    }
    if (skillsAndTrainingEnabled) {
        if (filterData === null || filterData === void 0 ? void 0 : filterData.languageIds) {
            data.push({ column: 'languageIds', op: 'overlap', value: filterData.languageIds });
        }
        if (filterData === null || filterData === void 0 ? void 0 : filterData.skillIds) {
            data.push({ column: 'skillIds', op: 'overlap', value: filterData.skillIds });
        }
        if ((filterData === null || filterData === void 0 ? void 0 : filterData.trainingCourseIds) && (filterData === null || filterData === void 0 ? void 0 : filterData.trainingStatusSet)) {
            const courseIds = filterData.trainingCourseIds;
            const value = filterData.trainingStatusSet.flatMap((statusId) => courseIds.map((courseId) => courseId + '_' + statusId));
            data.push({ column: 'trainingStatus', op: 'overlap', value });
        }
        else {
            if (filterData === null || filterData === void 0 ? void 0 : filterData.trainingCourseIds) {
                data.push({ column: 'trainingCourseIds', op: 'overlap', value: filterData.trainingCourseIds });
            }
            if (filterData === null || filterData === void 0 ? void 0 : filterData.trainingStatusSet) {
                data.push({ column: 'trainingStatusSet', op: 'overlap', value: filterData.trainingStatusSet });
            }
        }
    }
    if (isTrainFeatureEnabled(userState)) {
        if (filterData === null || filterData === void 0 ? void 0 : filterData.trainCourseIds) {
            data.push({
                op: 'in',
                idSubFilter: {
                    entity: accountTrainCourseEntityName,
                    column: 'accountId',
                    filter: [
                        {
                            column: 'courseId',
                            op: 'in',
                            value: filterData.trainCourseIds,
                        },
                    ],
                },
            });
        }
        if (filterData.trainCourseTrainId) {
            data.push({
                op: 'in',
                idSubFilter: {
                    entity: accountTrainCourseEntityName,
                    column: 'accountId',
                    filter: [
                        {
                            column: 'courseId',
                            op: 'in',
                            subFilter: {
                                entity: trainCourseEntityName,
                                filter: [
                                    {
                                        column: 'trainId',
                                        op: '=',
                                        value: parseInt(filterData.trainCourseTrainId),
                                    },
                                ],
                            },
                        },
                    ],
                },
            });
        }
    }
    return { data: data, isLoading: false };
}
